import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatErr } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, LifeBuoy, Save } from "lucide-react";

export function SupportConfig() {
    const [form, setForm] = useState({ support_url: "", support_email: "" });
    const [loaded, setLoaded] = useState(false);
    const [busy, setBusy] = useState(false);

    const load = () => api.get("/admin/support-config").then((r) => {
        setForm({ support_url: r.data.support_url || "", support_email: r.data.support_email || "" });
        setLoaded(true);
    });
    useEffect(() => { load().catch(() => setLoaded(true)); }, []);

    const save = async () => {
        setBusy(true);
        try { await api.put("/admin/support-config", form); toast.success("Support settings saved"); }
        catch (err) { toast.error(formatErr(err.response?.data?.detail)); } finally { setBusy(false); }
    };

    return (
        <div className="bg-white border border-border rounded-xl overflow-hidden max-w-2xl" data-testid="support-config-card">
            <div className="px-5 py-4 border-b border-border flex items-center gap-2 text-brand-emerald font-semibold">
                <LifeBuoy className="h-4 w-4 text-brand-teal" /> Help &amp; Support
            </div>
            <div className="p-5 space-y-4">
                <p className="text-sm text-muted-foreground">Where school users go to get help. The support request link (and optional email) appear on the in-app <b>Help &amp; Support</b> page for every school.</p>
                <div>
                    <Label className="text-xs">Support request URL</Label>
                    <Input value={form.support_url} onChange={(e) => setForm({ ...form, support_url: e.target.value })} placeholder="https://support.borrowageek.com/new-ticket" className="mt-1" data-testid="support-url-input" />
                    <p className="text-[11px] text-muted-foreground mt-1">e.g. a helpdesk portal, ticket form or shared inbox link. Opens in a new tab.</p>
                </div>
                <div>
                    <Label className="text-xs">Support email (optional fallback)</Label>
                    <Input value={form.support_email} onChange={(e) => setForm({ ...form, support_email: e.target.value })} placeholder="support@borrowageek.com" className="mt-1" data-testid="support-email-input" />
                </div>
                <div className="flex justify-end">
                    <Button disabled={busy || !loaded} onClick={save} className="bg-brand-emerald hover:bg-brand-emeraldhover rounded-lg" data-testid="support-save">
                        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="h-4 w-4 mr-1" /> Save</>}
                    </Button>
                </div>
            </div>
        </div>
    );
}
